import useBrowser from "../../hooks/useBrowser";

import Modal from "./Modal";
import ProjectEditor from "../editors/ProjectEditor";

const ProjectModal = ({ projectId, open, onClose, onSave, clientId }) => {
  const { windowHeight } = useBrowser();

  return (
    <Modal
      title={projectId ? "project_update" : "project_new"}
      open={open}
      onClose={onClose}
      height={`${windowHeight}px`}
    >
      <ProjectEditor
        onSave={onSave}
        clientId={clientId}
        projectId={projectId}
      />
    </Modal>
  );
};

export default ProjectModal;
